import React from 'react'
import { useTranslation } from 'react-i18next'
import { Progress, Icon } from 'semantic-ui-react'
import cn from 'classnames'

const ProgressBar = ({ currentStepIndex, stepsLength, progress }) => {
  const { t } = useTranslation()
  const lastStepIndex = stepsLength - 1
  const isCompleted = currentStepIndex === lastStepIndex
  const progressText = (
    // There is a problem when use Fragment and Google translate on code
    // that will dissapear by an action. Because of that this div don't should
    // be changed to Fragment
    <div>
      <strong>
        {t('Progress')}: {currentStepIndex}
      </strong>
      /{lastStepIndex}
    </div>
  )

  return (
    <div className='flex vertical progress-container'>
      <div>{isCompleted ? <strong>Completed</strong> : progressText}</div>
      <div className={cn('bar-container', { full: isCompleted })}>
        <Progress className='progress-bar' size='tiny' percent={progress} />
        {isCompleted ? <Icon name='check' /> : <strong>{progress}%</strong>}
      </div>
    </div>
  )
}

export default ProgressBar
